// @ts-strict-ignore
import React from 'react';
import {eventWithTime} from '@rrweb/types';

import {RecordingEventMetadata, RecordingInactivePeriod, RecordingMetadata, TimelineType} from '../types';
import {splitEventsByType} from '../util';
import {RecordingPlayerTimeline} from './index';
import styles from './index.module.styl';

type MultiTimelineContainerProps = {
  replay: RecordingMetadata;
  replayEvents: RecordingEventMetadata[];
  recordingDuration: number;
  recordingProgress: number;
  replayInactivePeriods: RecordingInactivePeriod[];
  pageloadEvents: eventWithTime[];
  searchFilter: string;
  isStitchingEnabled: boolean;
  onUpdatePlayerProgress: (timestampMs: number) => void;
  currentHoveredEvent: RecordingEventMetadata | null;
  setCurrentHoveredEvent: (event: RecordingEventMetadata | null) => void;
};

export function MultiTimelineContainer(props: MultiTimelineContainerProps) {
  const {insightfulEvents, regularEvents, stitchedEvents} = splitEventsByType(props.replayEvents);
  return (
    <div className={styles.multiTimelineContainer}>
      <div className={styles.mainProgressBar}>
        <RecordingPlayerTimeline
          replay={props.replay}
          replayEvents={regularEvents}
          recordingDuration={props.recordingDuration}
          recordingProgress={props.recordingProgress}
          replayInactivePeriods={props.replayInactivePeriods}
          pageloadEvents={props.pageloadEvents}
          searchFilter={props.searchFilter}
          onUpdatePlayerProgress={props.onUpdatePlayerProgress}
          isStitchingEnabled={props.isStitchingEnabled}
          currentHoveredEvent={props.currentHoveredEvent}
          setCurrentHoveredEvent={props.setCurrentHoveredEvent}
          timelineType={TimelineType.Main}
        />
      </div>

      {stitchedEvents.length > 0 && (
        <div className={styles.timelineContainer}>
          <div className={styles.timelineWrapper}>
            <RecordingPlayerTimeline
              replay={props.replay}
              replayEvents={stitchedEvents}
              recordingDuration={props.recordingDuration}
              recordingProgress={props.recordingProgress}
              replayInactivePeriods={props.replayInactivePeriods}
              pageloadEvents={props.pageloadEvents}
              searchFilter={props.searchFilter}
              onUpdatePlayerProgress={props.onUpdatePlayerProgress}
              isStitchingEnabled={props.isStitchingEnabled}
              currentHoveredEvent={props.currentHoveredEvent}
              setCurrentHoveredEvent={props.setCurrentHoveredEvent}
              timelineType={TimelineType.Stitched}
            />
          </div>
        </div>
      )}

      {insightfulEvents.length > 0 && (
        <div className={styles.timelineContainer}>
          <div className={styles.timelineWrapper}>
            <RecordingPlayerTimeline
              replay={props.replay}
              replayEvents={insightfulEvents}
              recordingDuration={props.recordingDuration}
              recordingProgress={props.recordingProgress}
              replayInactivePeriods={props.replayInactivePeriods}
              pageloadEvents={props.pageloadEvents}
              searchFilter={props.searchFilter}
              onUpdatePlayerProgress={props.onUpdatePlayerProgress}
              isStitchingEnabled={props.isStitchingEnabled}
              currentHoveredEvent={props.currentHoveredEvent}
              setCurrentHoveredEvent={props.setCurrentHoveredEvent}
              timelineType={TimelineType.Insightful}
            />
          </div>
        </div>
      )}
    </div>
  );
}
